import { useNavigate } from "react-router-dom";
import { useNavigationFeedback } from "../contexts/NavigationFeedbackContext";

export const useNavigateWithFeedback = () => {
  const navigate = useNavigate();
  const { startNavigation } = useNavigationFeedback();

  return (to, options) => {
    startNavigation();
    navigate(to, options);
  };
};
